module.exports = __webpack_public_path__ + "img/MenuButton_JQ.01f6fb32.jpg";